// Generated by Avo VERSION 232.43.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
var AvoEnv = /*#__PURE__*/ function(AvoEnv) {
    AvoEnv["Prod"] = "prod";
    AvoEnv["Dev"] = "dev";
    return AvoEnv;
}({});
let __AVO_ENV__ = null;
// @ts-ignore
let __AVO_NOOP__ = false;
// @ts-ignore
let __AVO_LOGGER__ = null;
// @ts-ignore
let __REPORT_FAILURE_AS__ = null;
// @ts-ignore
let __WEB_DEBUGGER__ = true;
const avoInspectorApiKey = "0EK2wgZRRlNgpZrE3dVz";
let __INSPECTOR__ = null;
let InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties) {
        const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
            return;
        }
        typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
    },
    log: function log(message) {
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
            return;
        }
        typeof console !== 'undefined' && console.log("[avo] " + message);
    },
    warn: function warn(message) {
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
            return;
        }
        typeof console !== 'undefined' && console.warn("[avo] " + message);
    },
    error: function error(message, error) {
        if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
            return;
        }
        typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
};
function convertPropertiesArrayToMap(propertiesArray) {
    let result = {};
    propertiesArray.forEach((value)=>{
        result[value.name] = value.value;
    });
    return result;
}
let _avo_invoke;
let _avo_invoke_meta;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
    // @ts-ignore
    if (typeof window === 'undefined') {
        return;
    }
    if (_avo_sampling_rate > 0) {
        if (Math.random() < _avo_sampling_rate) {
            // @ts-ignore
            fetch("https://api.avo.app/i", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "ac": "YOMc8MardQA6g0MSWNyt",
                    "br": "master",
                    "en": env,
                    "ev": eventId,
                    "ha": hash,
                    "sc": "LUdm3yClzyKtZ3VfmBf2",
                    "se": new Date().toISOString(),
                    "so": "sPisQrkN-OQ_ue9vnEXIa",
                    "va": messages.length === 0,
                    "me": messages,
                    "or": origin
                })
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                _avo_sampling_rate = data.sa;
            }).catch(function() {});
        }
    }
};
_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
    // @ts-ignore
    if (typeof window === 'undefined') {
        return;
    }
    if (_avo_sampling_rate > 0) {
        if (Math.random() < _avo_sampling_rate) {
            // @ts-ignore
            fetch("https://api.avo.app/i", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "ac": "YOMc8MardQA6g0MSWNyt",
                    "br": "master",
                    "en": env,
                    "ty": type,
                    "sc": "LUdm3yClzyKtZ3VfmBf2",
                    "se": new Date().toISOString(),
                    "so": "sPisQrkN-OQ_ue9vnEXIa",
                    "va": messages.length === 0,
                    "me": messages,
                    "or": origin
                })
            }).then(function(res) {
                return res.json();
            }).then(function(data) {
                _avo_sampling_rate = data.sa;
            }).catch(function() {});
        }
    }
};
let _avo_debugger_log;
let _avo_debugger_events_during_boot = [];
let _avo_debugger_ready = false;
if (typeof window !== 'undefined') {
    window.addEventListener("message", function(event) {
        if (event.origin !== "https://www.avo.app") {
            return;
        }
        let iframe = document.getElementById("avo-debugger");
        if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
            iframe.style = event.data.style;
        } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
            let message = {
                type_: "avo-debugger-boot-events",
                schemaId: "LUdm3yClzyKtZ3VfmBf2",
                href: window.location.href,
                events: _avo_debugger_events_during_boot
            };
            _avo_debugger_events_during_boot = [];
            _avo_debugger_ready = true;
            iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger");
        }
    });
}
_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
    if (typeof window === 'undefined') {
        return;
    }
    let event = {
        eventId: eventId,
        eventName: eventName,
        messages: messages,
        timestamp: Date.now(),
        eventProperties,
        userProperties,
        groupProperties
    };
    if (_avo_debugger_ready) {
        let message = {
            type_: "avo-debugger-events",
            events: [
                event
            ]
        };
        document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger");
    } else {
        _avo_debugger_events_during_boot.push(event);
    }
};
function _avo_debugger_send_position(position) {
    if (typeof window === 'undefined') {
        return;
    }
    window.addEventListener("message", function(event) {
        if (event.origin !== "https://www.avo.app") {
            return;
        }
        if (event.data.type_ === "avo-debugger-ready" && position !== null) {
            var message = {
                type_: "avo-debugger-position",
                position: position
            };
            document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger");
        }
    });
}
const UserStatus = {
    'LOGGED_IN': 'logged_in',
    'LOGGED_OUT': 'logged_out'
};
const ConsentStatus = {
    'DENIED': 'denied',
    'GRANTED': 'granted',
    'PENDING': 'pending'
};
const Language = {
    'FR': 'fr',
    'DE': 'de',
    'EN': 'en',
    'NL': 'nl'
};
const DeviceType = {
    'DESKTOP': 'desktop',
    'MOBILE': 'mobile',
    'TABLET': 'tablet'
};
let IWTTrackingBFF;
function initAvo(options, destinationOptions, IWTTrackingBFFDestination) {
    if (__AVO_ENV__ !== null) {
        return;
    }
    __AVO_ENV__ = options.env;
    if (options.avoLogger !== undefined) {
        __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
        __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == "prod") {
        InternalAvoLogger.warn("[avo] ****************************************************");
        InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
        InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
        InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
        InternalAvoLogger.warn("[avo] ****************************************************");
        __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
        InternalAvoLogger.log("[avo] ****************************************************");
        InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
        InternalAvoLogger.log("[avo] - No events will be sent");
        InternalAvoLogger.log("[avo] - No network requests are made");
        InternalAvoLogger.log("[avo] ****************************************************");
    }
    if (options.strict !== undefined) {
        options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
        __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && (typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1 || options.webDebugger !== false && __AVO_ENV__ !== "prod");
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
        __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
        InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
    }
    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
        if (options.webDebuggerOptions?.position) {
            _avo_debugger_send_position(options.webDebuggerOptions.position);
        }
        (function() {
            if (typeof window === 'undefined') {
                return;
            }
            let init = function() {
                let iframe = document.createElement("iframe");
                document.body.appendChild(iframe);
                iframe.id = "avo-debugger";
                iframe.src = "https://www.avo.app/_debugger";
                iframe.style = "display: none;";
            };
            if (document.body) {
                init();
            } else {
                document.addEventListener('DOMContentLoaded', init);
            }
        })();
    }
    if (!__AVO_NOOP__) {
        IWTTrackingBFF = IWTTrackingBFFDestination;
        if (__AVO_ENV__ === 'prod') {
            IWTTrackingBFF && IWTTrackingBFF.make && IWTTrackingBFF.make(__AVO_ENV__, null);
        } else if (__AVO_ENV__ === 'dev') {
            IWTTrackingBFF && IWTTrackingBFF.make && IWTTrackingBFF.make(__AVO_ENV__, null);
        } else {
            console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for IWT Tracking BFF. Head to destination settings in Avo to set a staging key.");
            IWTTrackingBFF && IWTTrackingBFF.make && IWTTrackingBFF.make(__AVO_ENV__, null);
        }
        if (__AVO_ENV__ === "dev") {
            // debug console in Avo
            _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
        }
    }
}
var Avo = {
    AvoEnv,
    initAvo,
    avoInspectorApiKey,
    UserStatus,
    ConsentStatus,
    Language,
    DeviceType
} // AVOMODULEMAP:"Avo"
 // AVOEVENTMAP:["viewPage","viewClassifiedList","viewClassifiedInList","clickClassified","clickSaveClassified","clickUnsaveClassified","viewClassifiedDetail","clickContactForm","confirmContactForm","clickPhoneReveal","clickPhoneNumber"]
;

var AvoRuntime = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AvoEnv: AvoEnv,
  ConsentStatus: ConsentStatus,
  DeviceType: DeviceType,
  get IWTTrackingBFF () { return IWTTrackingBFF; },
  InternalAvoLogger: InternalAvoLogger,
  Language: Language,
  UserStatus: UserStatus,
  get __AVO_ENV__ () { return __AVO_ENV__; },
  get __AVO_LOGGER__ () { return __AVO_LOGGER__; },
  get __AVO_NOOP__ () { return __AVO_NOOP__; },
  get __INSPECTOR__ () { return __INSPECTOR__; },
  get __REPORT_FAILURE_AS__ () { return __REPORT_FAILURE_AS__; },
  get __WEB_DEBUGGER__ () { return __WEB_DEBUGGER__; },
  get _avo_debugger_log () { return _avo_debugger_log; },
  get _avo_invoke () { return _avo_invoke; },
  get _avo_invoke_meta () { return _avo_invoke_meta; },
  avoInspectorApiKey: avoInspectorApiKey,
  convertPropertiesArrayToMap: convertPropertiesArrayToMap,
  default: Avo,
  initAvo: initAvo
});

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// Event hashes for Inspector tracking
const EVENT_HASH_DSnuQELVg8gkLu8HWOP8H_405ed346 = "97c638bc81082a0d7ccabc0931e0fc73c2056c47ab83a9338d624173704f31dc";
const EVENT_HASH__8iHEkHWOeMkoiwOr_0qoP_3e8f750f = "66997b7cfe417c8c0c751fca04f5a3178919a29f297da0124aea56931bc5b113";
const EVENT_HASH__98iQEJyipAVtW7s8P_UrE_74c4b2fb = "04422379a34b8b035ab97bf20c185f862fa9cef75d997ecca2a660a1faea3e25";
const EVENT_HASH_fG7guNrCl6n0ng8vF24K2_296b8fd1 = "0437354fc725e3e04316fe47f78d1c8b00502ad72e345edd3f46e3eb10dfd93c";
const EVENT_HASH_K_UU_sy9PIHEP2191VvJa_1332a632 = "d870d92a26a3efe348e2045099bb21476b350555f7db2f8452d634f2495a2049";
const EVENT_HASH_J2pF1xUytlynLsxG9AluK_0199b30e = "47de1d26d29e69258fc3398b360db459be85cb64eb18dce61c647a38b1c0ac88";
const EVENT_HASH_WtYWfjcAXJ_6UXazosoyp_7efd5c80 = "4971003e6658a4847d0a59741b599ea8fc0a9d262a02a0106a4c44d5fe8a644f";
const EVENT_HASH__2tDaXMlsTXxz9cgE_5Xcy_08bbb75d = "140f14875404ef3a07a65f09f53a9d0f6dabe994426fbef59f52abd54fbd1b72";
const EVENT_HASH_LF3RuyHgWrxskzCutZpQT_490fbc1a = "765bd389334991a3ad874792277bdda41536a106064974ba770eac481b9bc85a";
const EVENT_HASH__3ZGqihOZcHz9nBvyU0ISM_0e6e28d2 = "9f304f575e0e5ebf96ea121d587378f376a1fe73a0e1c6cd1ec432ea546ba00d";
const EVENT_HASH_vyUZmnlpggTyrfDekTTb5_38256877 = "d44e900bb4a9d0c30e82f9c7f8646629fb3920d8633f03f50cd520a42762a2e5";

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * view_page: Every page load or URL change
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/1GKPyioa3SO2vM1itbxSp
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/J6X3V1QXGexucf_CwxI2s
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/pTgzRg5VrBgefV-rimGVT
 * 4. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/ROPhIsnvIsLRsUlXDyiMR
 * 5. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/UaA3aWY6m4f9Kz0I2O2UJ
 * 6. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/emhC1EaS5TAxA1iU2QjO5
 * 7. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/lT4SUN1CXOrOIIyHgJ0J6
 * 8. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H/trigger/qZjgyKdl_EOqOu_QGkBxB
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/DSnuQELVg8gkLu8HWOP8H}
 */ function viewPage(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "DSnuQELVg8gkLu8HWOP8H", EVENT_HASH_DSnuQELVg8gkLu8HWOP8H_405ed346, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("view_page", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("DSnuQELVg8gkLu8HWOP8H", "view_page", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_page", eventProperties, "DSnuQELVg8gkLu8HWOP8H", EVENT_HASH_DSnuQELVg8gkLu8HWOP8H_405ed346);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("view_page", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * view_classified_list: Search results rendered.
 * Fired when search results are returned and rendered. Captures the full state of the search,  including the query ID and all applied filters, at that moment.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP/trigger/z8ye9w4Nxr8aRAZeFUyz1
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP/trigger/ejxeIdgav2UjDK3p3K88g
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP/trigger/0b_ECMjam2swradEOyYOp
 * 4. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP/trigger/2t_LWFSOvRln-yjUuAh_t
 * 5. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP/trigger/Wl3EQSlZhjpoaGQHOnnIW
 * 6. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP/trigger/azGzzwS9odIsHSh4XHd9B
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * @param properties.listName: Context identifier for the list displayed
 * @param properties.listPageNumber: Results page number, starting from 1
 * @param properties.listPosition: Position of the list on the page/screen, in relation to all the other lists on the page/screen.
 * Starting from 1
 * @param properties.itemPosition: Position context if applicable
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/8iHEkHWOeMkoiwOr-0qoP}
 */ function viewClassifiedList(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: properties.listName
    });
    properties.listPageNumber !== undefined && properties.listPageNumber !== null ? eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: properties.listPageNumber
    }) : eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: null
    });
    properties.listPosition !== undefined && properties.listPosition !== null ? eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: properties.listPosition
    }) : eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: null
    });
    eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: properties.itemPosition
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "8iHEkHWOeMkoiwOr-0qoP", EVENT_HASH__8iHEkHWOeMkoiwOr_0qoP_3e8f750f, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("view_classified_list", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("8iHEkHWOeMkoiwOr-0qoP", "view_classified_list", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_classified_list", eventProperties, "8iHEkHWOeMkoiwOr-0qoP", EVENT_HASH__8iHEkHWOeMkoiwOr_0qoP_3e8f750f);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("view_classified_list", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * view_classified_in_list: Fired when a listing card explicitly enters the user's viewport, not when it is rendered in the DOM. This is an active impression, detected via IntersectionObserver.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/98iQEJyipAVtW7s8P-UrE/trigger/CMZuJ5mZALPXiXYf2unMQ
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/98iQEJyipAVtW7s8P-UrE/trigger/Eyl3NnoeURO233fouoP2U
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/98iQEJyipAVtW7s8P-UrE/trigger/MzP8bNcjRBzjdHz3wpynZ
 * 4. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/98iQEJyipAVtW7s8P-UrE/trigger/POwha99PQHCB91wpqeJGH
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.itemId: Unique listing identifier. Classified ID. 
 * From it, item-specific data is attached like:
 * index
 * name
 * list_name
 * id
 * price
 * estate_type
 * distribution_type
 * country
 * city
 * region
 * province
 * currency
 * zip_code
 * building_state
 * legacy_id
 * product_type
 * client_id (on item level)
 * energy_certificate (on item level)
 * promotion
 * etc.
 * @param properties.itemPosition: Position context if applicable
 * @param properties.listPageNumber: Results page number, starting from 1
 * @param properties.listPosition: Position of the list on the page/screen, in relation to all the other lists on the page/screen.
 * Starting from 1
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * @param properties.listName: Context identifier for the list displayed
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/98iQEJyipAVtW7s8P-UrE}
 */ function viewClassifiedInList(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    eventPropertiesArray.push({
        id: "YLr4h04h9TEzHecxTJPE5",
        name: "item_id",
        value: properties.itemId
    });
    eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: properties.itemPosition
    });
    properties.listPageNumber !== undefined && properties.listPageNumber !== null ? eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: properties.listPageNumber
    }) : eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: null
    });
    properties.listPosition !== undefined && properties.listPosition !== null ? eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: properties.listPosition
    }) : eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: null
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: properties.listName
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "98iQEJyipAVtW7s8P-UrE", EVENT_HASH__98iQEJyipAVtW7s8P_UrE_74c4b2fb, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("view_classified_in_list", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("98iQEJyipAVtW7s8P-UrE", "view_classified_in_list", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_classified_in_list", eventProperties, "98iQEJyipAVtW7s8P-UrE", EVENT_HASH__98iQEJyipAVtW7s8P_UrE_74c4b2fb);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("view_classified_in_list", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_classified: Fired when a user clicks on a listing card on the SERP to open the CDP.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2/trigger/CyZ3L6Zr37NeZj0SfdHX4
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2/trigger/4c2KqpkvsexitWwY2IlWo
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2/trigger/asMzgolzNSA57_zpPz4eZ
 * 
 * @param properties the properties associated with this event
 * @param properties.itemId: Unique listing identifier. Classified ID. 
 * From it, item-specific data is attached like:
 * index
 * name
 * list_name
 * id
 * price
 * estate_type
 * distribution_type
 * country
 * city
 * region
 * province
 * currency
 * zip_code
 * building_state
 * legacy_id
 * product_type
 * client_id (on item level)
 * energy_certificate (on item level)
 * promotion
 * etc.
 * @param properties.itemPosition: Position context if applicable
 * @param properties.listName: Context identifier for the list displayed
 * @param properties.listPosition: Position of the list on the page/screen, in relation to all the other lists on the page/screen.
 * Starting from 1
 * @param properties.listPageNumber: Results page number, starting from 1
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/fG7guNrCl6n0ng8vF24K2}
 */ function clickClassified(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "YLr4h04h9TEzHecxTJPE5",
        name: "item_id",
        value: properties.itemId
    });
    eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: properties.itemPosition
    });
    eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: properties.listName
    });
    properties.listPosition !== undefined && properties.listPosition !== null ? eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: properties.listPosition
    }) : eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: null
    });
    properties.listPageNumber !== undefined && properties.listPageNumber !== null ? eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: properties.listPageNumber
    }) : eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: null
    });
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "fG7guNrCl6n0ng8vF24K2", EVENT_HASH_fG7guNrCl6n0ng8vF24K2_296b8fd1, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_classified", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("fG7guNrCl6n0ng8vF24K2", "click_classified", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_classified", eventProperties, "fG7guNrCl6n0ng8vF24K2", EVENT_HASH_fG7guNrCl6n0ng8vF24K2_296b8fd1);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_classified", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_save_classified: Fired when a user saves a listing from their wishlist
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/K-UU_sy9PIHEP2191VvJa/trigger/EbtDrMFrJg8bOx1VSkmf1
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/K-UU_sy9PIHEP2191VvJa/trigger/LTTi8b6Pw-_FRGhvLqVmQ
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.itemId: Unique listing identifier. Classified ID. 
 * From it, item-specific data is attached like:
 * index
 * name
 * list_name
 * id
 * price
 * estate_type
 * distribution_type
 * country
 * city
 * region
 * province
 * currency
 * zip_code
 * building_state
 * legacy_id
 * product_type
 * client_id (on item level)
 * energy_certificate (on item level)
 * promotion
 * etc.
 * @param properties.listPosition: Position of the list on the page/screen, in relation to all the other lists on the page/screen.
 * Starting from 1
 * @param properties.listName: Context identifier for the list displayed
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * @param properties.listPageNumber: Results page number, starting from 1
 * @param properties.itemPosition: Position context if applicable
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/K-UU_sy9PIHEP2191VvJa}
 */ function clickSaveClassified(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    eventPropertiesArray.push({
        id: "YLr4h04h9TEzHecxTJPE5",
        name: "item_id",
        value: properties.itemId
    });
    properties.listPosition !== undefined && properties.listPosition !== null ? eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: properties.listPosition
    }) : eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: null
    });
    properties.listName !== undefined && properties.listName !== null ? eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: properties.listName
    }) : eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: null
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    properties.listPageNumber !== undefined && properties.listPageNumber !== null ? eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: properties.listPageNumber
    }) : eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: null
    });
    properties.itemPosition !== undefined && properties.itemPosition !== null ? eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: properties.itemPosition
    }) : eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "K-UU_sy9PIHEP2191VvJa", EVENT_HASH_K_UU_sy9PIHEP2191VvJa_1332a632, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_save_classified", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("K-UU_sy9PIHEP2191VvJa", "click_save_classified", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_save_classified", eventProperties, "K-UU_sy9PIHEP2191VvJa", EVENT_HASH_K_UU_sy9PIHEP2191VvJa_1332a632);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_save_classified", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_unsave_classified: Fired when a user removes a listing from their wishlist
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/J2pF1xUytlynLsxG9AluK/trigger/ONKdjgV-OqV7acv6uHbpu
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/J2pF1xUytlynLsxG9AluK/trigger/dcZhbEm-KqWBe41ADwYZp
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.itemId: Unique listing identifier. Classified ID. 
 * From it, item-specific data is attached like:
 * index
 * name
 * list_name
 * id
 * price
 * estate_type
 * distribution_type
 * country
 * city
 * region
 * province
 * currency
 * zip_code
 * building_state
 * legacy_id
 * product_type
 * client_id (on item level)
 * energy_certificate (on item level)
 * promotion
 * etc.
 * @param properties.itemPosition: Position context if applicable
 * @param properties.listName: Context identifier for the list displayed
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * @param properties.listPageNumber: Results page number, starting from 1
 * @param properties.listPosition: Position of the list on the page/screen, in relation to all the other lists on the page/screen.
 * Starting from 1
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/J2pF1xUytlynLsxG9AluK}
 */ function clickUnsaveClassified(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    eventPropertiesArray.push({
        id: "YLr4h04h9TEzHecxTJPE5",
        name: "item_id",
        value: properties.itemId
    });
    properties.itemPosition !== undefined && properties.itemPosition !== null ? eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: properties.itemPosition
    }) : eventPropertiesArray.push({
        id: "jXrS-V2GLqLi3c10J62z3",
        name: "item_position",
        value: null
    });
    properties.listName !== undefined && properties.listName !== null ? eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: properties.listName
    }) : eventPropertiesArray.push({
        id: "-iXATsEeE-QF75Hb1n21c",
        name: "list_name",
        value: null
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    properties.listPageNumber !== undefined && properties.listPageNumber !== null ? eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: properties.listPageNumber
    }) : eventPropertiesArray.push({
        id: "Sr3XSSH8UIABSAbvKChtQ",
        name: "list_page_number",
        value: null
    });
    properties.listPosition !== undefined && properties.listPosition !== null ? eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: properties.listPosition
    }) : eventPropertiesArray.push({
        id: "T0vR2srKzPDn6tIt4meYH",
        name: "list_position",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "J2pF1xUytlynLsxG9AluK", EVENT_HASH_J2pF1xUytlynLsxG9AluK_0199b30e, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_unsave_classified", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("J2pF1xUytlynLsxG9AluK", "click_unsave_classified", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_unsave_classified", eventProperties, "J2pF1xUytlynLsxG9AluK", EVENT_HASH_J2pF1xUytlynLsxG9AluK_0199b30e);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_unsave_classified", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * view_classified_detail: Fired when the classified content is fully loaded and visible to the user. Distinct from page_view , this event marks the actual exposure to a listing, not just the technical page load.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/WtYWfjcAXJ_6UXazosoyp/trigger/oOqBcIOzK61ir_6nuTv93
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/WtYWfjcAXJ_6UXazosoyp/trigger/N6SlVTOzSJLADAhXSzsIb
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/WtYWfjcAXJ_6UXazosoyp}
 */ function viewClassifiedDetail(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "WtYWfjcAXJ_6UXazosoyp", EVENT_HASH_WtYWfjcAXJ_6UXazosoyp_7efd5c80, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("view_classified_detail", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("WtYWfjcAXJ_6UXazosoyp", "view_classified_detail", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_classified_detail", eventProperties, "WtYWfjcAXJ_6UXazosoyp", EVENT_HASH_WtYWfjcAXJ_6UXazosoyp_7efd5c80);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("view_classified_detail", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_contact_form: Fired when the contact form is opened or displayed to the user, triggered by any CTA that surfaces the form (main button, sticky bar, etc.).
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/2tDaXMlsTXxz9cgE-5Xcy/trigger/JwE0iGoAM9MHYBIgKK_l0
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/2tDaXMlsTXxz9cgE-5Xcy/trigger/XNUbN5bkGsdf-7lH1Vvpt
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/2tDaXMlsTXxz9cgE-5Xcy/trigger/zeBirHYxvTJDNxRAHs51n
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.formType: Type of contact form displayed
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/2tDaXMlsTXxz9cgE-5Xcy}
 */ function clickContactForm(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    eventPropertiesArray.push({
        id: "SvsuEajF0rSCrsoiB2l5k",
        name: "form_type",
        value: properties.formType
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "2tDaXMlsTXxz9cgE-5Xcy", EVENT_HASH__2tDaXMlsTXxz9cgE_5Xcy_08bbb75d, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_contact_form", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("2tDaXMlsTXxz9cgE-5Xcy", "click_contact_form", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_contact_form", eventProperties, "2tDaXMlsTXxz9cgE-5Xcy", EVENT_HASH__2tDaXMlsTXxz9cgE_5Xcy_08bbb75d);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_contact_form", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * confirm_contact_form: It must only fire after the server has confirmed the form submission,  never on button click. Firing on click would inflate lead counts with unconfirmed submissions.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/LF3RuyHgWrxskzCutZpQT/trigger/ZDcFAZdJl-eSG_qPhGLcv
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/LF3RuyHgWrxskzCutZpQT/trigger/zo8R1FEMQVes2hi4X7lN0
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/LF3RuyHgWrxskzCutZpQT/trigger/LAA9wDwR-76GB38dLVytH
 * 4. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/LF3RuyHgWrxskzCutZpQT/trigger/REK2kQAFretfrmhUPTywI
 * 5. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/LF3RuyHgWrxskzCutZpQT/trigger/YBdJzVsL5nbl4TLoHbbqa
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.formType: Type of contact form displayed
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/LF3RuyHgWrxskzCutZpQT}
 */ function confirmContactForm(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    eventPropertiesArray.push({
        id: "SvsuEajF0rSCrsoiB2l5k",
        name: "form_type",
        value: properties.formType
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "LF3RuyHgWrxskzCutZpQT", EVENT_HASH_LF3RuyHgWrxskzCutZpQT_490fbc1a, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("confirm_contact_form", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("LF3RuyHgWrxskzCutZpQT", "confirm_contact_form", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("confirm_contact_form", eventProperties, "LF3RuyHgWrxskzCutZpQT", EVENT_HASH_LF3RuyHgWrxskzCutZpQT_490fbc1a);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("confirm_contact_form", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_phone_reveal: Fired when the phone number is revealed to the user  when they click the "Show number" button and the number becomes visible.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/3ZGqihOZcHz9nBvyU0ISM/trigger/iusIRbWIh_CIE5zth67o3
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/3ZGqihOZcHz9nBvyU0ISM/trigger/TZs6Fk8EwJbHfcOtbIWFK
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/3ZGqihOZcHz9nBvyU0ISM/trigger/oVPWsAoz7qFMirFRIRECm
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/3ZGqihOZcHz9nBvyU0ISM}
 */ function clickPhoneReveal(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "3ZGqihOZcHz9nBvyU0ISM", EVENT_HASH__3ZGqihOZcHz9nBvyU0ISM_0e6e28d2, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_phone_reveal", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("3ZGqihOZcHz9nBvyU0ISM", "click_phone_reveal", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_phone_reveal", eventProperties, "3ZGqihOZcHz9nBvyU0ISM", EVENT_HASH__3ZGqihOZcHz9nBvyU0ISM_0e6e28d2);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_phone_reveal", Object.assign({}, eventProperties));
    }
}

// Generated by Avo. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */ /* eslint-disable */ // @ts-nocheck
/**
 * click_phone_number: Fired when a call is initiated by the user via a tap on the phone number link. This event is primarily relevant on mobile, on desktop, a click on a tel: link may not result in an actual call.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/vyUZmnlpggTyrfDekTTb5/trigger/jJo-xkB4jrr72AXNcy432
 * 2. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/vyUZmnlpggTyrfDekTTb5/trigger/YpizBhfv899aPCwXyhs9V
 * 3. 
 * View in Avo: https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/vyUZmnlpggTyrfDekTTb5/trigger/o0uwNyPVB1q_tC1zMgTao
 * 
 * @param properties the properties associated with this event
 * @param properties.consentStatus: User consent status.
 * @param properties.deviceType: Device category of the user.
 * @param properties.externalSource: Source of traffic from where user came to platform, based on referral or utm parameters.
 * @param properties.correlationId: Shared identifier connecting all events on one page session. Generated when a page is served,  retrieved from server side, passed to the front-end, and included in every behaviour event on that page. This is the join key in Snowflake Silver.
 * @param properties.visitorId: Anonymous visitor ID (always present).
 * More info - https://avivgroup.atlassian.net/wiki/spaces/GPJ/pages/3531341825/Implementation+of+visitor_id+Field+and+value
 * @param properties.language: Website's language, lowercase, code ISO2.
 * @param properties.customerId: Agency owner ID. 
 * To be sent only when an owner is logged in.
 * @param properties.customerType: Agency owner type
 * @param properties.pagePath: URL path (web) or screen name (iOS/Android) where the event fires.
 * @param properties.pageTitle: Title of the page where the event fires.
 * @param properties.category: Page category / type
 * @param properties.sessionId: Unique session identifier. Persists across events within the same session.
 * @param properties.eventTs: ISO 8601 timestamp of the event, in UTC. Generated at push time., should match regex: ^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(\.\d\d\d)?Z$
 * @param properties.searchId: Unique search query identifier (ID) — links all events from the same search session.
 * To be sent by the SERP team
 * @param properties.referrerListName: Origin list context if navigating from a list. Origin list name, example:
 * classified_search_results
 * homepage_zero_recommendations
 * homepage_saved_search
 * homepage_recently_viewed
 * homepage_new_builds
 * 
 * @see {@link https://www.avo.app/schemas/LUdm3yClzyKtZ3VfmBf2/events/vyUZmnlpggTyrfDekTTb5}
 */ function clickPhoneNumber(properties) {
    // Get destinations from AvoRuntime
    const { AvoEnv, __AVO_ENV__, __AVO_NOOP__, InternalAvoLogger, _avo_invoke, convertPropertiesArrayToMap, __WEB_DEBUGGER__, _avo_debugger_log, __INSPECTOR__, IWTTrackingBFF } = AvoRuntime;
    // @ts-ignore
    let eventPropertiesArray = [];
    eventPropertiesArray.push({
        id: "_6cqxbkv6W4xEB8PC4Xpu",
        name: "consent_status",
        value: properties.consentStatus
    });
    eventPropertiesArray.push({
        id: "efUwQU4uxkz0Bi775JdrQ",
        name: "device_type",
        value: properties.deviceType
    });
    properties.externalSource !== undefined && properties.externalSource !== null ? eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: properties.externalSource
    }) : eventPropertiesArray.push({
        id: "BDyFFt8whd2i4Ay-gfuyZ",
        name: "external_source",
        value: null
    });
    eventPropertiesArray.push({
        id: "1RUhk98uAW4Y4ClCX09Ej",
        name: "correlation_id",
        value: properties.correlationId
    });
    eventPropertiesArray.push({
        id: "hufa_LXsgS1Eec4wJjTtl",
        name: "visitor_id",
        value: properties.visitorId
    });
    eventPropertiesArray.push({
        id: "daTjIkcRGbjJoBY7oxDVi",
        name: "language",
        value: properties.language
    });
    properties.customerId !== undefined && properties.customerId !== null ? eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: properties.customerId
    }) : eventPropertiesArray.push({
        id: "o6vaDuP7bv002M7lE3sDu",
        name: "customer_id",
        value: null
    });
    properties.customerType !== undefined && properties.customerType !== null ? eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: properties.customerType
    }) : eventPropertiesArray.push({
        id: "y2yVSV0cfM2AAUIrF2sTC",
        name: "customer_type",
        value: null
    });
    eventPropertiesArray.push({
        id: "sFm7VUITGnVvDFLOipGYk",
        name: "page_path",
        value: properties.pagePath
    });
    eventPropertiesArray.push({
        id: "TwHs_RDpk4Zh1gKF5sIbt",
        name: "page_title",
        value: properties.pageTitle
    });
    eventPropertiesArray.push({
        id: "F3vZwlfp-E7t-uxuLEdFb",
        name: "category",
        value: properties.category
    });
    eventPropertiesArray.push({
        id: "AH9RZn9cUL1lu2IutzXub",
        name: "session_id",
        value: properties.sessionId
    });
    eventPropertiesArray.push({
        id: "2eW_tkpve2BjUkSiPYCqW",
        name: "event_ts",
        value: properties.eventTs
    });
    properties.searchId !== undefined && properties.searchId !== null ? eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: properties.searchId
    }) : eventPropertiesArray.push({
        id: "03aZTZ7XClufZrcAiMdKO",
        name: "search_id",
        value: null
    });
    properties.referrerListName !== undefined && properties.referrerListName !== null ? eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: properties.referrerListName
    }) : eventPropertiesArray.push({
        id: "fn7SBynDFvipAUfiyfKSI",
        name: "referrer_list_name",
        value: null
    });
    let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray);
    // @ts-ignore
    let userPropertiesArray = [];
    let userProperties = convertPropertiesArrayToMap(userPropertiesArray);
    // assert properties
    if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
        let messages = [];
        // debug console in Avo
        if (!__AVO_NOOP__) {
            _avo_invoke(__AVO_ENV__, "vyUZmnlpggTyrfDekTTb5", EVENT_HASH_vyUZmnlpggTyrfDekTTb5_38256877, messages.map((m)=>Object.assign({}, {
                    tag: m.tag,
                    propertyId: m.propertyId,
                    additionalProperties: m.additionalProperties,
                    actualType: m.actualType
                })), 'event');
        }
        InternalAvoLogger.logEventSent("click_phone_number", eventProperties, userProperties);
        if (__WEB_DEBUGGER__) {
            // Avo web debugger
            _avo_debugger_log("vyUZmnlpggTyrfDekTTb5", "click_phone_number", messages, eventPropertiesArray, userPropertiesArray, []);
        }
    }
    if (!__AVO_NOOP__) {
        if (__INSPECTOR__ != null) {
            // @ts-ignore
            __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click_phone_number", eventProperties, "vyUZmnlpggTyrfDekTTb5", EVENT_HASH_vyUZmnlpggTyrfDekTTb5_38256877);
        }
        // destination IWTTrackingBFF
        IWTTrackingBFF.logEvent("click_phone_number", Object.assign({}, eventProperties));
    }
}

// Only initialize avo-inspector on client-side to avoid SSR errors.
const inspectorInstance = (appId)=>typeof window === "undefined" ? Promise.resolve(undefined) : import('avo-inspector').then((Inspector)=>{
        return new Inspector.AvoInspector({
            // Todo: potentially move this to env variable
            apiKey: "0EK2wgZRRlNgpZrE3dVz",
            env: Inspector.AvoInspectorEnv.Prod,
            version: "1.0.0",
            appName: appId
        });
    });

export { Avo, AvoEnv, clickClassified, clickContactForm, clickPhoneNumber, clickPhoneReveal, clickSaveClassified, clickUnsaveClassified, confirmContactForm, inspectorInstance, viewClassifiedDetail, viewClassifiedInList, viewClassifiedList, viewPage };
